import FiscalSintegraService from "@/services/FiscalSintegraService";

export const fiscalSintegra = {
  namespaced: true,
  state: {},
  actions: {
    getFiscalSintegraJobsOData(_, payload) {
      return FiscalSintegraService.GetJobsOData(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error)
      );
    },
    postFiscalSintegraJob(_, payload) {
      return FiscalSintegraService.PostJob(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    deleteFiscalSintegraJob(_, payload) {
      return FiscalSintegraService.DeleteJob(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    downloadFiscalSintegraJob(_, payload) {
      return FiscalSintegraService.DownloadJob(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error)
      );
    },
    getFiscalSintegraFiltros() {
      return FiscalSintegraService.GetFiltros().then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
  },
  mutations: {},
};

export default fiscalSintegra;
